import { render, staticRenderFns } from "./DashboardFolder.vue?vue&type=template&id=c220393c&"
import script from "./DashboardFolder.vue?vue&type=script&lang=js&"
export * from "./DashboardFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports